


import React, { useState } from "react";
import Foodtab from "./Foodtab.js";
import Foodscreens from "./Foodscreens.js";
import FoodVideosTable from "./FoodVideosTable.js";

const Foodaddsvideos = () => {

    // ✅ TAB STATE
    const [activeTab, setActiveTab] = useState("Create Screens");

    // ✅ SCREEN STATES (from second code)
    const [showScreenModal, setShowScreenModal] = useState(false);
    const [screens, setScreens] = useState([]);

    const handleSaveScreens = (updatedScreens) => {
        console.log("Screens saved:", updatedScreens);
        setScreens(updatedScreens);
    };

    // ✅ RENDER LOGIC (UPDATED)
    const renderComponent = () => {
        switch (activeTab) {

            case "Create Screens":
                return (
                    <Foodscreens
                        showScreenModal={showScreenModal}
                        setShowScreenModal={setShowScreenModal}
                        onSaveScreens={handleSaveScreens}
                        addedScreens={screens}
                    />
                );

            case "Screens":
                return <Foodtab />;

            default:
                return (
                    <Foodscreens
                        showScreenModal={showScreenModal}
                        setShowScreenModal={setShowScreenModal}
                        onSaveScreens={handleSaveScreens}
                        addedScreens={screens}
                    />
                );
        }
    };

    // ✅ TABS
    const tabs = [

        "Create Screens",
        "Screens",

    ];

    return (
        <div className="tabs-wrapper">

            {/* ✅ TOP TABS */}
            <div className="tabs-row">
                {tabs.map((tab) => (
                    <span
                        key={tab}
                        className={`row-tab ${activeTab === tab ? "active" : ""}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </span>
                ))}
            </div>

            {/* ✅ SCROLLABLE CONTENT */}
            <div
                className="tabs-content"
                style={{
                    overflowY: "auto",
                    scrollbarWidth: "none",
                    height: "calc(85vh - 120px)"
                }}
            >
                {renderComponent()}
            </div>

        </div>
    );
};

export default Foodaddsvideos;